<script setup lang="ts">
  import { ChevronDown } from 'lucide-vue-next';
  import { IconImage, Popover, PopoverContent, PopoverTrigger } from '@/shared/ui';

  interface Props {
    open: boolean;
    iconSrc: string | object;
    label: string;
  }

  defineProps<Props>();

  defineEmits<{
    (e: 'update:open', value: boolean): void;
  }>();
</script>

<template>
  <Popover
    :open="open"
    @update:open="$emit('update:open', $event)"
  >
    <PopoverTrigger as-child>
      <button
        v-tippy="{
          content: label,
          placement: 'top',
          theme: 'custom',
          trigger: 'mouseenter',
          hideOnClick: true,
        }"
        type="button"
        class="flex h-8 w-12 cursor-pointer items-center justify-center rounded bg-transparent text-[var(--color-gray-03)] transition-colors hover:bg-[var(--color-gray-01)]"
        :aria-label="label"
      >
        <span class="inline-flex items-center gap-1">
          <IconImage
            class="w-5 h-5 shrink-0 overflow-visible"
            :src="iconSrc"
            :alt="label"
          />
          <ChevronDown class="w-3.5 h-3.5 shrink-0 text-light-gray-xx" />
        </span>
      </button>
    </PopoverTrigger>
    <PopoverContent
      side="bottom"
      :side-offset="4"
      class="w-auto p-2"
    >
      <slot />
    </PopoverContent>
  </Popover>
</template>
